import { useEffect, useState } from "react";

export function useIsMobile() {
  const [mobile, setMobile] = useState(() => window.innerWidth < 768);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const on = () => setMobile(mq.matches);
    mq.addEventListener("change", on);
    setMobile(mq.matches);
    return () => mq.removeEventListener("change", on);
  }, []);
  return mobile;
}

export function defaultDay(days) {
  const today = new Date().toLocaleDateString("en-GB", { weekday: "long" });
  return days.includes(today) ? today : days[0];
}
